import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import get from 'lodash/get';

import getVisitTypeName from '../../../../../utils/appointments/getVisitTypeName';
import styles from './index.styl';

const EirVisitTypeHeaderTopSection = ({ appointment }) => {
  const { formatMessage } = useIntl();
  const organization = get(appointment, 'organization');

  const name = get(organization, 'name');
  const thumbMin = get(organization, 'logo.thumbMin');
  const visitName = get(appointment, 'visitType.name');
  const visitTypeCode = get(appointment, 'visitType.code');

  const visitTypeName = getVisitTypeName({
    sourceOfCreation: get(appointment, 'sourceOfCreation'),
    defaultValue: visitName,
    formatMessage,
    visitTypeCode,
  });

  return (
    <section className={styles.section}>
      <img
        style={{ width: 32, height: 32 }}
        src={thumbMin}
        alt="organization-logo"
      />
      <div className={styles.titles}>
        <div className={styles.title}>{visitTypeName}</div>
        <div className={styles.subtitle}>{name}</div>
      </div>
    </section>
  );
};

EirVisitTypeHeaderTopSection.propTypes = {
  appointment: PropTypes.object,
};

export default EirVisitTypeHeaderTopSection;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentDetailsPopup/EirVisitTypeHeaderTopSection/index.jsx